import React from 'react';
import './Footer.scss';
import { Link } from 'react-router-dom';
import logo from '../../../assets/City Pharmacy.png';
import visa from '../../../assets/visacard.png';
import mastercard from '../../../assets/mastercardicon.png';
import paypal from '../../../assets/paypalicoin.png';

const Footer = () => {
  return (
    <div className="Footer">
      <div className="footer-wrapper">
        <div className="upperbox">
          <div className="box">
            <h3 className="head">Navigation</h3>
            <div className="itms">
              <Link className="item" to="/">
                Home
              </Link>
              <Link className="item" to="/About">
                About
              </Link>
              <Link className="item" to="/Contact">
                Contact
              </Link>
              <Link className="item" to="/Shop">
                Shop Products
              </Link>
            </div>
          </div>
          <div className="box">
            <h3 className="head">Prescription</h3>
            <div className="itms">
              <Link className="item" to="/Fillprescription">
                Fill Prescription Online 
              </Link>
              <Link className="item" to="/Refillprescription">
                Prescription Refill
              </Link>
              <Link className="item" to="/Transferprescription">
                Prescription Transfer
              </Link>
            </div>
          </div>
          <div className="box">
            <h3 className="head">Services</h3>
            <div className="itms">
              <Link className="item" to="/Consult_a_pharmacist">
                Consult a Pharmacist
              </Link>
              <Link className="item" to="/MinorAliments">
                Minor Ailments{' '}
              </Link>
              <Link className="item" to="/Travel">
                Travel Health & Vaccines{' '}
              </Link>
              <Link className="item" to="/Compression">
                Compression Therapy{' '}
              </Link>
              <Link className="item" to="/Vaccinations">
                Vaccinations
              </Link>
              <Link className="item" to="/Testing">
                Testing
              </Link>
            </div>
          </div>
          <div className="box">
            <h3 className="head">LEGAL</h3>
            <div className="itms">
              <Link className="item" to="/Shipping_policy">
                Shipping & Return Policy
              </Link>
              <Link className="item" to="/Privacy_policy">
                Privacy Policy
              </Link>
              <Link className="item" to="/Terms">
                Terms of Use
              </Link>
            </div>
          </div>
          <div className="box">
            <h3 className="head">talk with us</h3>
            <div className="itms">
              <a className="item" href="tel:+4164691898">
                Phone: 416.469.1898
              </a>
              <a className="item" href="fax:+4164691898">
                Fax: 416.469.5464
              </a>
              <a className="item" href="mailto:info@citypharmacy.ca">
                Email: info@citypharmacy.ca
              </a>
            </div>
          </div>
        </div>
        <div className="paymentcards">
          <img src={visa} alt="card" />
          <img src={mastercard} alt="card" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="37"
            viewBox="0 0 56 37"
            fill="none"
          >
            <path
              d="M51.3613 0H5.11133C2.55701 0 0.486328 2.07068 0.486328 4.625V32.375C0.486328 34.9293 2.55701 37 5.11133 37H51.3613C53.9157 37 55.9863 34.9293 55.9863 32.375V4.625C55.9863 2.07068 53.9157 0 51.3613 0Z"
              fill="#016FD0"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.3164 30.9755V17.791L55.7826 17.8121V21.454L53.0703 24.3525L55.7826 27.2775V30.9967H51.4522L49.1508 28.4572L46.8658 31.0064L32.3164 30.9755Z"
              fill="#FFFFFE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.8828 29.5283V19.2402H42.6062V21.6103H36.7073V23.2191H42.4656V25.5497H36.7073V27.1298H42.6062V29.5283H33.8828Z"
              fill="#016FD0"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M42.5637 29.5281L47.3906 24.3781L42.5635 19.2402H46.2997L49.2492 22.5009L52.2072 19.2402H55.7827V19.3212L51.0586 24.3781L55.7827 29.3821V29.5281H52.1712L49.1693 26.2347L46.1983 29.5281H42.5637Z"
              fill="#016FD0"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.4102 6.08789H39.0667L41.0535 10.5992V6.08789H48.0369L49.2411 9.46777L50.4494 6.08789H55.7819V19.2724H27.6006L33.4102 6.08789Z"
              fill="#FFFFFE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.4819 7.51562L29.917 17.7951H33.0479L33.9091 15.7366H38.5756L39.4362 17.7951H42.645L38.0991 7.51562H34.4819ZM34.8742 13.4297L36.2432 10.1573L37.6112 13.4297H34.8742Z"
              fill="#016FD0"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M42.6016 17.7949V7.51562L47.0025 7.53075L49.2671 13.8502L51.5464 7.51562H55.7819V17.7949L53.0564 17.819V10.7581L50.4836 17.7949H47.9958L45.3696 10.734V17.7949H42.6016Z"
              fill="#016FD0"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="37"
            viewBox="0 0 57 37"
            fill="none"
          >
            <path
              d="M51.855 36.4217L51.8599 36.4217C54.0686 36.4406 55.8806 34.6349 55.9082 32.3846L55.9082 4.63957C55.8994 3.55128 55.4662 2.51177 54.7051 1.7501C53.9459 0.990372 52.9226 0.569219 51.855 0.578289L5.6128 0.578268C4.5501 0.569219 3.52679 0.990372 2.7676 1.7501C2.00648 2.51177 1.57333 3.55128 1.56447 4.63486L1.56445 32.3604C1.57333 33.4487 2.00648 34.4882 2.7676 35.2499C3.52679 36.0096 4.5501 36.4308 5.61773 36.4217H51.855ZM51.8526 37.578C51.8517 37.578 51.8509 37.5779 51.85 37.5779L51.855 37.578H51.8526Z"
              fill="white"
              stroke="#F8F8F8"
              strokeWidth="1.15625"
            />
            <path
              d="M30.1523 37.0013H51.8548C53.0729 37.0115 54.2453 36.5374 55.1138 35.6831C55.9824 34.8289 56.476 33.6647 56.4861 32.4465V26.9922C48.291 31.6965 39.4032 35.0747 30.1523 37.0013Z"
              fill="#F27712"
            />
            <path
              d="M54.5728 21.497H52.6016L50.3816 18.5689H50.1711V21.497H48.5635V14.2246H50.9366C52.793 14.2246 53.8647 14.9901 53.8647 16.368C53.8647 17.4972 53.1949 18.2244 51.9892 18.4541L54.5728 21.497ZM52.1997 16.4254C52.1997 15.7173 51.6638 15.3537 50.6687 15.3537H50.1711V17.5546H50.6304C51.6638 17.5546 52.1997 17.1718 52.1997 16.4254ZM42.937 14.2246H47.4918V15.4494H44.5445V17.0761H47.3769V18.3201H44.5445V20.2913H47.4918V21.5161H42.937V14.2246ZM37.7697 21.6884L34.2866 14.2054H36.0473L38.2482 19.1048L40.4682 14.2054H42.1906L38.6692 21.6884H37.808H37.7697ZM23.2057 21.6692C20.7561 21.6692 18.8423 20.0042 18.8423 17.8417C18.8423 15.7365 20.7944 14.0332 23.244 14.0332C23.933 14.0332 24.5071 14.1672 25.2152 14.4734V16.1575C24.679 15.6307 23.9575 15.3352 23.2057 15.3346C21.6747 15.3346 20.5073 16.4446 20.5073 17.8417C20.5073 19.3153 21.6556 20.3679 23.2823 20.3679C24.0095 20.3679 24.5645 20.1382 25.2152 19.5641V21.2482C24.488 21.5544 23.8756 21.6692 23.2057 21.6692ZM18.3447 19.277C18.3447 20.6932 17.1773 21.6692 15.4932 21.6692C14.2683 21.6692 13.388 21.2482 12.6416 20.2913L13.6942 19.3918C14.0578 20.0425 14.6702 20.3679 15.4357 20.3679C16.163 20.3679 16.6797 19.9277 16.6797 19.3535C16.6797 19.0282 16.5266 18.7794 16.2013 18.588C15.8445 18.4149 15.4731 18.274 15.0913 18.167C13.5794 17.6885 13.0626 17.1718 13.0626 16.1575C13.0626 14.971 14.1726 14.0715 15.6271 14.0715C16.5457 14.0715 17.3687 14.3585 18.0576 14.8944L17.2156 15.8513C16.8818 15.4854 16.4094 15.277 15.9142 15.2772C15.2252 15.2772 14.7276 15.6217 14.7276 16.081C14.7276 16.4637 15.0147 16.6742 15.9716 16.9996C17.8088 17.5737 18.3447 18.1096 18.3447 19.2961V19.277ZM10.4407 14.2246H12.0483V21.5161H10.4407V14.2246ZM5.27349 21.5161H2.90039V14.2246H5.27349C7.87625 14.2246 9.67522 15.7173 9.67522 17.8608C9.67522 18.9517 9.13936 19.9851 8.2016 20.6741C7.39781 21.2482 6.49832 21.5161 5.25436 21.5161H5.27349ZM7.14901 16.0427C6.61315 15.6217 6.00074 15.4685 4.94815 15.4685H4.50798V20.2913H4.94815C5.9816 20.2913 6.63229 20.0999 7.14901 19.7172C7.70401 19.2579 8.02936 18.5689 8.02936 17.8608C8.02936 17.1527 7.70401 16.4829 7.14901 16.0427Z"
              fill="#F27712"
            />
            <path
              d="M29.6938 14.0332C27.5886 14.0332 25.8662 15.7173 25.8662 17.8034C25.8662 20.0234 27.5121 21.6884 29.6938 21.6884C31.8372 21.6884 33.5214 20.0042 33.5214 17.8608C33.5214 15.7173 31.8564 14.0332 29.6938 14.0332Z"
              fill="#F27712"
            />
          </svg>
          <img src={paypal} alt="card" />
        </div>
        <hr className="hr" />
        <div className="lower">
          <p>© 2023 CityPharmacy. All Rights Reserved. </p>
          <img src={logo} alt="logo" />
          <p>
            Designed & Developed by{' '}
            <Link to="https://www.webelocity.io/" target="_blank">
              Webelocity
            </Link>{' '}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
